import React from 'react';
import PortfoliosProgressItem from '../dashboard/portfolios/PortfoliosProgressItem';
import {ReactComponent as moneyIcon} from '../../assets/money.svg';
import {ReactComponent as rocketIcon} from '../../assets/rocket.svg';
import {ReactComponent as stackIcon} from '../../assets/stack.svg';
import {ReactComponent as calendarIcon} from '../../assets/calendar.svg';
import {ReactComponent as acceleratorIcon} from '../../assets/accelerator.svg';
import { Utilities } from '../../utility/utils';
import { Box, ITheme, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PortfolioStatus } from '../../models/Portfolio';
import { useAppSelector } from '../../store/reducers/store';

const PortfolioDetailsCircle: React.FC = () => {
    const theme = useTheme() as ITheme;
    const portfolio = useAppSelector(state => state.portfolioDetails.portfolio);
    const { t, i18n } = useTranslation();
    const toCoord = (coord: number[]): { x: number, y: number } => {
        return { x: coord[0], y: coord[1] };
    }
    const radiusX = 1000;
    const radiusY = 350;
    const radius = 360;
    const circleRadius = radius + 30;
    const summary = {
        capitalRaised: 11000000,
        capitalRemaining: 89000000,
        fundraisingTarget: 100000000,
        closingIn: 132,
        status: PortfolioStatus.Live
    }
    // Utilities.f_svg_rotate_coord([0, 370], 0).map((value))
    if (summary === undefined) {
        return <></>;
    }
    const statusToText = (status: PortfolioStatus): string => {
        switch (status) {
            case PortfolioStatus.Live:
                return t('PortfolioDetailsStatusOpen');
            case PortfolioStatus.Pending:
                return t('PortfolioDetailsStatusPending');
            case PortfolioStatus.Closed:
                return t('PortfolioDetailsStatusClosed');
            case PortfolioStatus.Draft:
                return t('PortfolioDetailsStatusDraft');
        }
    }

    return <Box flexShrink={0}>
        <svg width={radiusX} height={radiusY} viewBox={`0 0 ${radiusX} ${radiusY}`} fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: "-50px" }}>
            {portfolio && <>
                <g transform={`translate(${radiusX / 2 - 15},-${radiusY / 2})`}>
                    <path d={Utilities.f_svg_ellipse_arc([0, 0], [circleRadius, circleRadius], [0, 3 * Math.PI / 5], Math.PI / 5)} stroke={theme.palette.leo.primary.blue[100]} strokeWidth="5" strokeDasharray={"900"} strokeDashoffset={"900"} className='drawable-illustration' />
                    <PortfoliosProgressItem coord={toCoord(Utilities.f_svg_rotate_coord([0, radius], 3 * Math.PI / 10))} icon={rocketIcon} title={t('PortfolioDetailsProgressTitle1')} value={`€ ${portfolio.raisedAmount?.toLocaleString(i18n.language)}`} align='end' animationDelay="1.2s" />
                    <PortfoliosProgressItem coord={toCoord(Utilities.f_svg_rotate_coord([0, radius], 3 * Math.PI / 20))} icon={stackIcon} title={t('PortfolioDetailsProgressTitle2')} value={`€ ${(portfolio.fundraisingTarget - portfolio.raisedAmount)?.toLocaleString(i18n.language)}`} align='end' animationDelay="0.9s" />
                    <PortfoliosProgressItem coord={toCoord(Utilities.f_svg_rotate_coord([0, radius], 0))} icon={moneyIcon} title={t('PortfolioDetailsProgressTitle3')} value={`€ ${portfolio.fundraisingTarget?.toLocaleString(i18n.language)}`} align='center' animationDelay="0.6s" />
                    <PortfoliosProgressItem coord={toCoord(Utilities.f_svg_rotate_coord([0, radius], -3 * Math.PI / 20))} icon={calendarIcon} title={t('PortfolioDetailsProgressTitle4')} value={`${(Math.floor((portfolio.closingDate.getTime() - Date.now())/(1000*3600*24)))?.toLocaleString(i18n.language)} ${t('PortfolioDetailsProgressTitle4Days')}`} align='start' animationDelay="0.3s" />
                    <PortfoliosProgressItem coord={toCoord(Utilities.f_svg_rotate_coord([0, radius], -3 * Math.PI / 10))} icon={acceleratorIcon} title={t('PortfolioDetailsProgressTitle5')} value={`${statusToText(portfolio.status)}`} align='start' />
                </g>
            </>}
        </svg>
    </Box>;
}

export default PortfolioDetailsCircle;